<div class="row form-group" *ngIf="ErrorList != null && ErrorList.length > 0">
    <div class="col">
        <div class="alert alert-danger">
            <b translate>ERR.ERR_CORRECT_ERROR</b>
            <div *ngFor="let row of ErrorList" translate>{{CheckErrorType(row.ErrorMessage)}}</div>
        </div>
    </div>
</div>
